import creditEngineRepository, { CreditEngineRepository } from './CreditEngineRepository'

const resource = '/loan';
export default {
  createLoan(loanCreationPayload) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}`, loanCreationPayload);
  },

  updateLoanStage(loanId, loanStageId, loanStage, loanStatus) {
    const query = "?loanId=" + loanId + "&loanStageId=" + loanStageId + "&loanStage=" + loanStage
      + "&loanStatus=" + loanStatus;
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}/loanStageUpdate${query}`);
  },

  getLoanDisplayElements(loanId) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(`${resource}/${loanId}/loanDetailsDisplayElements`);
  }
}
